<script setup lang="ts">
import type { RTEBlock } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

const props = defineProps<{
  data: RTEBlock;
  componentStyles?: ComponentStyles;
}>();

const componentStylesWithoutBgColor = computed(() =>
  [
    props.componentStyles?.rowSpacingTop,
    props.componentStyles?.rowSpacingBottom,
    props.componentStyles?.sectionPaddingTop,
    props.componentStyles?.sectionPaddingBottom
  ].filter(Boolean)
);
</script>

<template>
  <section
    v-if="data.richText"
    class="narrow-container component container"
    :class="componentStylesWithoutBgColor"
  >
    <BaseRte
      :content="data.richText"
      class="px-8 py-6"
      :class="componentStyles?.bgColor"
    />
  </section>
</template>
